<template>
  <div class="comment-add">
    <div class="box-user-img">
      <ImageWrapper v-if="$store.getters.user.idPicture" :file="$store.getters.user.idPicture"></ImageWrapper>
      <img v-else src="../../assets/images/avatar-placeholder.png">
    </div>
    <div class="comment-add-content form-block--attachments">
      <label class="d-lg-none">Your comment</label>
      <textarea v-model="comment.content"></textarea>

      <label class="d-lg-none">Attachments</label>
      <CommentAttachmentsInput :files="comment.attachments" :gallery="comment.images" @addImage="val => comment.images=val">
        <template v-slot:cancel>
          <button class="link cancel-comment d-none d-lg-flex" @click="cancel"><span>Cancel</span></button>
        </template>
        <template v-slot:add>
          <button class="button-icon button-icon--mobile-submit" @click="add">Add your comment <i class="icon-send"></i></button>
        </template>
      </CommentAttachmentsInput>
    </div>
  </div>
</template>

<script>
import CommentAttachmentsInput from "./CommentAttachmentsInput";
import api from "@/api/comments";
import ImageWrapper from "@/components/general/ImageWrapper";
export default {
name: "addComment",
props:['replayTo'],
data() {
  return {
    comment: {
      "content": null,
      "attachments": [],
      "images": [],
    },
  }
},
components: {ImageWrapper, CommentAttachmentsInput},
  computed: {
  },
  methods: {
    cancel() {
      this.comment = {
        "content": null,
        "attachments": [],
        "images": []
      }
      this.$emit('cancel')
    },
    add() {
      let data =  {
        commentText: this.comment.content,
        idUser: this.$store.getters.user.idUser,
      }
      if(this.$route.name === 'IdeaOverview') {
        data.idContent = this.$store.getters.idea.idContent
      }
      if(this.$route.name === 'NewsSingle') {
        data.idContent = this.$store.getters.newsSingle.idContent
      }
      if(this.replayTo) {
        data.idContentCommentParent = this.replayTo.idContentComment
      }
      if(this.comment.images.length) {
        data.idFile = this.comment.images[0].idFile
      }
      api.addComment(data, () => {
        this.$emit('add')
      })
    },
  }
}
</script>

<style scoped>

</style>
